/**
 * Take control and write any kind of query you wish to Klevu API. For experts only.
 *
 * @category Query
 * @param query
 * @param modifiers
 * @returns
 */
export function raw(query, ...modifiers) {
    return {
        klevuFunctionId: "raw",
        queries: [query],
        modifiers,
    };
}
